import React, { useCallback, useContext, useState } from "react";
import * as Sentry from "@sentry/react";
import { RootStoreContext } from "src/stores/RootStore";
import { observer } from "mobx-react-lite";
import { UI } from "@wwimmo/ui";
import { useTranslation } from "react-i18next";
import styles from "./AssemblyVoting.module.css";

interface IAssemblyVotingBase {
    assemblyid?: string;
}

const AssemblyVotingBase = observer((props: IAssemblyVotingBase) => {
    const { votingStore } = useContext(RootStoreContext);
    const { t } = useTranslation();

    const [results, setResults] = useState<{ id: string; selectedColumn: number | null }[]>([]);

    const handleSelectionChange = useCallback((data: { id: string; selectedColumn: number | null }[]) => {
        setResults(data);
    }, []);

    const handleSave = useCallback(() => {
        console.log("Voting results:", results);
        // Process or send the results as needed.
    }, [results]);

    if (votingStore.votingList.length <= 0 || votingStore.selectedVoting.votingid.length < 0) {
        return null;
    }

    return (
        <UI.Card>
            <div className={styles.VotingTitle}>{votingStore.selectedVoting.question}</div>
            <UI.Voting
                numberOfColumn={3}
                headers={["WQ", "Ja", "Enthaltung", "Nein"]}
                withMainRow={true}
                rows={[
                    { id: "r1", label: "Test label for row 1" },
                    { id: "r2", label: "Test label for row 2" },
                    { id: "r3", label: "Test label for row 3" },
                    { id: "r4", label: "Test label for row 4" }
                ]}
                buttonColors={["#194d00", "#f8a300", "#900000"]}
                onSelectionChange={handleSelectionChange}
                secondRowLabels={["104", "150", "240", "100"]}
            />
            <UI.Button onClick={handleSave} className={styles.SaveButton} label={t("labels.save")} />
        </UI.Card>
    );
});

export const AssemblyVoting = Sentry.withProfiler(AssemblyVotingBase);
